import React, { ReactNode, useState, useEffect } from 'react';
const TextExpand = (props: any) => {
    const {
        content,
        maxLen = 300,
        expandText = '展开',
        collapseText = '收起',
        // eslint-disable-next-line no-unused-vars
        contentRender = (_text: string, _handler: ReactNode) => {
        },
        // eslint-disable-next-line no-unused-vars
        onExpand = (_expanded: boolean) => {
        }
    } = props,
        [body, setBody] = useState<any>(null),
        [expanded, setExpanded] = useState<boolean>(false),
        [showBtn, setShowBtn] = useState<boolean>(false),
        /**
         * 获取截断后的文字
         * @param text
         */
        getText = (text: string): string => {
            return (text || '').slice(0, maxLen) + '...';
        };
    useEffect(() => {
        let contentBody = content || '';
        if (contentBody.length > maxLen) {
            contentBody = getText(contentBody);
            setShowBtn(true);
        }
        setBody(contentBody);
        return () => {
            setExpanded(false);
            setShowBtn(false);
        };
    }, [content]);

    /**
     * 展开、收起
     * @param status
     */
    const expandToggle = (status: boolean) => {
        let text = status ? content : getText(content);
        setExpanded(status);
        setBody(text);
        onExpand(status);
    },
        /**
         * 获取展开收起按钮
         */
        getExpandBtn = (): ReactNode =>
            showBtn ? (
                <span className="custom-text-expanded-handler" onClick={() => expandToggle(!expanded)} style={{color:'#3b70ff'}}>
                    {expanded ? collapseText : expandText}
                </span>
            ) : null;
    return contentRender(body, getExpandBtn());
};
export default TextExpand;